export default "__VITE_ASSET__DeDHkiJJ__"